import './SocialMediaMetaTagsSection.less';
import React from 'react';
import SectionCompetitorResults from '../../shared/SectionCompetitorResults';
import SectionMessage from '../../shared/SectionMessage';
import SectionTitle from '../../shared/SectionTitle';
import SectionTooltip from '../../shared/SectionTooltip';
import { SectionProps } from '../../types';
import HowToFix from '../../shared/HowToFix';

export default function SocialMediaMetaTagsSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className={`report-element ${result.status}`}
        >
            <SectionTitle
                title={title}
                status={result.status}
                passRate={passRate}
            />
            <div className="report-element-description">
                <SectionMessage
                    url={url}
                    status={result.status}
                    relevance={relevance}
                    message={result.message}
                    hasCompetitors={hasCompetitors}
                />

                <SocialMediaTagsResult
                    openGraph={result.open_graph}
                    twitter={result.twitter}
                />

                {result.how_to_fix && (
                    <HowToFix
                        title={title}
                        howToFix={result.how_to_fix}
                        howToFixVideo={result.how_to_fix_video}
                    />
                )}

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}

type SocialMediaTagsResultProps = {
    openGraph: {
        'og:description': string;
        'og:image': string;
        'og:site_name': string;
        'og:title': string;
        'og:type': string;
        'og:url': string;
    };
    twitter: {
        'twitter:card': string;
        'twitter:creator': string;
        'twitter:description': string;
        'twitter:image': string;
        'twitter:site': string;
        'twitter:title': string;
    };
};

function SocialMediaTagsResult({ openGraph, twitter }: SocialMediaTagsResultProps) {
    return (
        <div className="description-meta">
            {openGraph && Object.keys(openGraph).length > 0 && (
                <div className="stats-table-container open-graph">
                    <header>
                        <div className="col">Open Graph Meta Tags</div>
                        <div className="col"></div>
                    </header>

                    {Object.keys(openGraph).map((ogKey, idx) => {
                        return (
                            <div
                                className="row"
                                key={idx}
                            >
                                <div className="col">{ogKey}</div>
                                <div className="col">{openGraph[ogKey as keyof typeof openGraph]}</div>
                            </div>
                        );
                    })}
                </div>
            )}

            {twitter && Object.keys(twitter).length > 0 && (
                <div className="stats-table-container twitter-card">
                    <header>
                        <div className="col">Twitter Card Meta Tags</div>
                        <div className="col"></div>
                    </header>

                    {Object.keys(twitter).map((twitterKey, idx) => {
                        return (
                            <div
                                className="row"
                                key={idx}
                            >
                                <div className="col">{twitterKey}</div>
                                <div className="col">{twitter[twitterKey as keyof typeof twitter]}</div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
